export const GET_SUPPLY_NOTES = "GET_SUPPLY_NOTES";
export const REQUEST_SUPPLY_NOTES = "REQUEST_SUPPLY_NOTES";
export const OPEN_MODAL_SUPPLY_NOTES = "OPEN_MODAL_SUPPLY_NOTES";
export const CLOSE_MODAL_SUPPLY_NOTES = "CLOSE_MODAL_SUPPLY_NOTES";

const initialState = {
  supplyNotes: [],
  supplyNote: "",
  isLoading: false,
  openModal: false,
};

export const supplyNotesReducer = (state = initialState, { payload, type }) => {
  switch (type) {
    case REQUEST_SUPPLY_NOTES:
      return { ...state, isLoading: true };
    case GET_SUPPLY_NOTES:
      return { ...state, isLoading: false, supplyNotes: payload };
    case OPEN_MODAL_SUPPLY_NOTES:
      return { ...state, openModal: true, supplyNote: payload };
    case CLOSE_MODAL_SUPPLY_NOTES:
      return { ...state, openModal: false };
    default:
      return state;
  }
};
